export default function getListStyleType(level) {
  switch (level) {
    default:
      return "lower-latin";
  }
}
